import { createContext, useContext, type FC, type ReactNode } from 'react'
import { type PresentationModeStore } from 'widgets/PresentationMode'

export const PresentationModeContext = createContext<PresentationModeStore | null>(null)

export const usePresentationModeContext = () => {
  const context = useContext(PresentationModeContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with PresentationModeContext')

  return context
}

type IProviderPresentationModeProps = {
  value: PresentationModeStore
  children: ReactNode
}

export const ProviderPresentationMode: FC<IProviderPresentationModeProps> = ({
  value,
  children,
}) => {
  return (
    <PresentationModeContext.Provider value={value}>{children}</PresentationModeContext.Provider>
  )
}
